import { useEffect, useState } from "react";

import SavePaymentMethodForm from "./save_payment_method_form.js";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import './payment_method.css'
import Skeleton from '@mui/material/Skeleton';
import amex from '../../../resources/amex-icon.png'
import visa from '../../../resources/visa-icon.webp'
import mastercard from '../../../resources/mastercard-icon.jpg'
import discover from '../../../resources/discover-icon.png'
import { FaCircle } from "react-icons/fa";
import FullScreenOverlay from "../../../Components/FullScreenOverlay/FullScreenOverlay.js";
import { getAuth } from "firebase/auth";
import { del, get, post, put } from "../../../Services/api.js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function BillingPaymentMethod({ user_data, billingData }) {
    const auth = getAuth();
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [modalOpen, setModalOpen] = useState(false)
    const [clientSecret, setClientSecret] = useState('');
    const [default_payment_method, setDefault_payment_method] = useState(false)
    const [customer_id, setCustomer_id] = useState()

    const [getDateDone, setGetDataDone] = useState(false)

    useEffect(() => {
        getPaymentMethods()
    }, [billingData]);

    async function getPaymentMethods() {
        const idToken = await auth.currentUser?.getIdToken();
        const res_customer_id = await get("/api/billing/stripe/get-unique-stripe-customer-id?user_id=" + user_data.uid, {
            headers: {
                Authorization: idToken ? `Bearer ${idToken}` : undefined,
            }
        })
        setCustomer_id(res_customer_id)

        if (res_customer_id && res_customer_id != 500) {
            // get customer to see default payment method
            const res_customer = await get("/api/billing/stripe/get-customer?id=" + res_customer_id, {
                headers: {
                    Authorization: idToken ? `Bearer ${idToken}` : undefined,
                }
            }
            )

            // get all attached payment methods
            const res_payment_methods = await get("/api/billing/stripe/get-customer-payment-methods?id=" + res_customer_id, {
                headers: {
                    Authorization: idToken ? `Bearer ${idToken}` : undefined,
                }
            })
            const payment_methods = []
            if (res_payment_methods.data)
                res_payment_methods.data.map((method) => {
                    if (method.id === res_customer.invoice_settings.default_payment_method)
                        payment_methods.push({ ...method, default_payment_method: true })
                    else payment_methods.push(method)
                })
            setPaymentMethods(payment_methods)
        }

        // Show data
        setGetDataDone(true)
    }

    async function deletePaymentMethod(payment_method) {

        const res = await del("/api/billing/stripe/remove-payment-method?id=" + payment_method.id)
        // get all payment methods again
        getPaymentMethods(billingData)
    }
    async function setDefaultPaymentMethod(payment_method) {
        const res = await put("/api/billing/stripe/set-default-payment-method?id=" + payment_method.id + '&customer_id=' + customer_id)
        // get all payment methods again
        getPaymentMethods(billingData)
    }

    async function setupIntent() {
        const res = await post("/api/billing/stripe/setup-intent")
        setClientSecret(res.client_secret)
    }
    const options = { clientSecret: clientSecret };

    return (
        <div>
            <div className="flex flex_column gap_20">
                <div className="flex flex_wrap gap_20">
                    {getDateDone ? paymentMethods.map((method) => (
                        <div className="billing_payment_method flex flex_column gap_12">
                            <div className="flex gap_12">
                                <img src={
                                    method.card.display_brand == 'visa' ? visa :
                                        (method.card.display_brand == 'american_express' ? amex
                                            : (method.card.display_brand == 'mastercard' ? mastercard
                                                : method.card.display_brand == 'discover' ? discover
                                                    : null))
                                } width={50} height={32} className="billing_payment_method_card_image" />
                                <div>
                                    <div className="flex align_center">
                                        <div className="billing_payment_method_number_bullets">
                                            <FaCircle size={6} color="#1F2933" />
                                        </div>
                                        <div className="billing_payment_method_number_bullets">
                                            <FaCircle size={6} color="#1F2933" />
                                        </div>
                                        <div className="billing_payment_method_number_bullets">
                                            <FaCircle size={6} color="#1F2933" />
                                        </div>
                                        <div className="billing_payment_method_number_bullets">
                                            <FaCircle size={6} color="#1F2933" />
                                        </div>
                                        <p className="font_size_16">{method.card.last4}</p>
                                    </div>
                                    <p className="font_size_12">Expires {method.card.exp_month.toString().padStart(2, '0')}/{method.card.exp_year}</p>
                                </div>
                            </div>
                            <div className="flex gap_8">
                                <div>
                                    <p className="billing_payment_method_default cursor_default" >{method.default_payment_method ? 'Default' : null}</p>
                                    {!method.default_payment_method ? <button className="billing_payment_method_default_button cursor_pointer" onClick={() => setDefaultPaymentMethod(method)}>Default</button> : null}
                                </div>
                                {!method.default_payment_method ? <button className="billing_payment_method_delete cursor_pointer" onClick={() => deletePaymentMethod(method)}>Delete</button> : null}
                            </div>
                        </div>
                    )) :
                        <div className="billing_payment_method flex flex_column gap_12">
                            <div className="flex gap_12">
                                <Skeleton variant="rounded" width={50} height={32} />
                                <div>
                                    <Skeleton variant="text" width={90} height={20} />
                                    <Skeleton variant="text" width={70} height={20} />
                                </div>
                            </div>
                            <div className="flex gap_8">
                                <Skeleton variant="rounded" width={70} height={20} />
                                <Skeleton variant="rounded" width={70} height={20} />
                            </div>
                        </div>
                    }
                </div>

                {!(modalOpen && clientSecret) ?
                    <button className="billing_payment_method_default_button cursor_pointer" onClick={() => { setModalOpen(true); setupIntent(); }}>Add Payment Method</button>
                    : null}

                {(modalOpen && clientSecret) ?
                    <FullScreenOverlay modalOpen={modalOpen} setModalOpen={setModalOpen}>
                        <div className="billing_payment_method_add_div">
                            <div>
                                <Elements stripe={stripePromise} options={options}>
                                    <SavePaymentMethodForm user_data={user_data}
                                        default_payment_method={!paymentMethods.length ? true : default_payment_method}
                                        customer_id={customer_id}
                                        setDefault_payment_method={setDefault_payment_method}
                                        only_payment_method={!paymentMethods.length}
                                    />
                                </Elements>
                            </div>
                        </div>
                    </FullScreenOverlay>
                    : null}
            </div>
        </div>
    );
}


export default BillingPaymentMethod;